import PropTypes from 'prop-types';
import { Component } from 'react';
import LogEventRowAction from 'automation-ui-action-features/components/LogEventRowAction';
import { jsx as _jsx } from "react/jsx-runtime";
class CustomCodeActionHistoryCard extends Component {
  render() {
    const {
      actionLabel
    } = this.props;
    return /*#__PURE__*/_jsx(LogEventRowAction, {
      title: actionLabel
    });
  }
}
CustomCodeActionHistoryCard.propTypes = {
  actionLabel: PropTypes.node
};
export default CustomCodeActionHistoryCard;